import React, { useState } from "react";
import { ChevronLeft, Bicycle, CarFrontFill } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion11.module.scss";
const Accardion11 = () => {
  const [openAll , setOpenAll]=useState(false)

  const ItemList = [
    {
      id: "1",
      title: "افزودن وسیله نقلیه",
      link: "/addcar",
      active: window.location.pathname === "/addcar",
    },
    {
      id: "2",
      title: "لیست وسیله نقلیه",
      link: "/carlist",
      active: window.location.pathname === "/carlist",
    },
    {
      id: "3",
      title: "افزودن رنگ",
      link: "/addcolor",
      active: window.location.pathname === "/addcolor",
    },
    {
      id: "4",
      title: "لیست رنگ",
      link: "/colorlist",
      active: window.location.pathname === "/colorlist",
    },

  ];

  let value = false;
  ItemList.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });

  const openHandlerAll=()=>{
    if(openAll){
      setOpenAll(false)
    }
    else{
      setOpenAll(true)
    }
  }
  return (
    <div className={Style.componentHolder}>
      <div
        className={value || openAll ? Style.background : Style.accardionTitle}
        onClick={openHandlerAll}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>وسیله نقلیه </p>
          <CarFrontFill />
        </div>
      </div>
      <div className={value ||openAll ? Style.inneraccardionContent : Style.hidden}>
        <AccardionItem accardonItem={ItemList && ItemList} />
      </div>
    </div>
  );
};

export default Accardion11;
